import PropTypes from "prop-types";
import React, { Suspense, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import Sidebar from "../../components/Sidebar";
import { canAccessRoute } from "../../config/routeConfig";

const getInitialSidebarCollapsed = () => {
  try {
    return JSON.parse(localStorage.getItem("sidebarCollapsed") ?? "false");
  } catch {
    return false;
  }
};

const MainLayout = props => {
  const { isAuthenticated, role } = useSelector(state => state.auth);
  const location = useLocation();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    getInitialSidebarCollapsed,
  );

  const shouldShowSidebar =
    isAuthenticated &&
    canAccessRoute(location.pathname, role) &&
    location.pathname !== "/unauthorized";

  const contentMargin = shouldShowSidebar
    ? sidebarCollapsed
      ? "ml-16"
      : "ml-48"
    : "ml-0";
  const contentWidth = shouldShowSidebar
    ? sidebarCollapsed
      ? "w-[calc(100vw-4rem)]"
      : "w-[calc(100vw-16rem)]"
    : "w-full";

  return (
    <main>
      <Suspense>
        <div className="flex">
          {shouldShowSidebar && (
            <Sidebar
              isCollapsed={sidebarCollapsed}
              onToggleCollapse={setSidebarCollapsed}
            />
          )}
          <div
            className={`${contentMargin} flex-1 min-h-screen h-full ${contentWidth} transition-[margin,width] duration-300 ease-in-out`}
          >
            {props.children}
          </div>
        </div>
      </Suspense>
    </main>
  );
};

MainLayout.propTypes = { children: PropTypes.node };

export default MainLayout;
